const MuiPaper = {
  styleOverrides: {
    root: ({ theme }) => ({
      // border: `1px solid ${theme.palette.base[40]}`,
      border: `1px solid ${theme.palette.custom.stroke}`,
      borderRadius: "5px",
      backgroundColor: theme.palette.custom.container,
      color: theme.palette.custom.text,
    }),
    elevation1: ({ theme }) => ({
      boxShadow: `-1px 1px 3px ${theme.palette.base.main}12`,
    }),
    elevation2: ({ theme }) => ({
      boxShadow: `-2px 2px 4px ${theme.palette.base.main}12`,
    }),
    elevation3: ({ theme }) => ({
      boxShadow: `-2px 3px 6px ${theme.palette.base.main}12`,
    }),
    elevation4: ({ theme }) => ({
      boxShadow: `-3px 5px 18px ${theme.palette.base.main}12`,
    }),
    elevation5: ({ theme }) => ({
      boxShadow: `-3px 5px 24px ${theme.palette.base.main}26`,
    }),
    elevation6: ({ theme }) => ({
      boxShadow: `-4px 7px 30px ${theme.palette.base.main}26`,
    }),
    elevation7: ({ theme }) => ({
      boxShadow: `-5px 9px 36px ${theme.palette.base.main}26`,
    }),
    elevation8: ({ theme }) => ({
      boxShadow: `-6px 11px 42px ${theme.palette.base.main}26`,
    }),
  },
};

export default MuiPaper;
